<template>
  <div>
    <v-progress-circular
      centered
      :size="70"
      :width="7"
      color="purple"
      indeterminate
    ></v-progress-circular>
  </div>
</template>

<script>
export default {
  name: 'Loading'
}
</script>

<style lang="scss" scoped>
div {
  width: 100%;
  height: 100%;
  text-align: center;
}
</style>
